import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response ? fallback : "We couldn't reach the server. Check your connection and try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? `${(x.loc || []).slice(-1)[0]}: ${x.msg}` : "")).join(" ");
  return d.msg || fallback;
}

export const fileUrl = (kind, id) => `${BACKEND}/api/files/${kind}/${id}`;
export const docHref = (d) => d.external_url || (d.id ? fileUrl("documents", d.id) : "#");
export const mediaSrc = (v) => (!v ? "" : v.startsWith("media:") ? fileUrl("media", v.slice(6)) : v);

export function track(type, extra = {}) {
  api.post("/public/track", { type, path: window.location.pathname, ...extra }).catch(() => {});
}

export function utm() {
  const p = new URLSearchParams(window.location.search);
  const saved = JSON.parse(sessionStorage.getItem("hr_utm") || "{}");
  const cur = { utm_source: p.get("utm_source") || "", utm_medium: p.get("utm_medium") || "", utm_campaign: p.get("utm_campaign") || "" };
  const merged = cur.utm_source ? cur : saved;
  if (cur.utm_source) sessionStorage.setItem("hr_utm", JSON.stringify(cur));
  return { utm_source: "", utm_medium: "", utm_campaign: "", ...merged, referrer: document.referrer || "", landing_page: sessionStorage.getItem("hr_landing") || window.location.pathname };
}

export const money = (n) => `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
export const fmtDate = (s) => {
  if (!s) return "";
  const d = new Date(s.length === 10 ? `${s}T12:00:00` : s);
  return isNaN(d) ? s : d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};
export const fmtTime = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
};
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "");
